import CreditCardsCheckout from 'components/Cart/CreditCardsCheckout'
import { createUseStyles } from 'react-jss'
import style from './style'
import { TypographyElement, Button, Icon, Icons } from 'UI'
import Text from './text.json'
import { confirmationStep } from '../UI'

const useStyles = createUseStyles(style)
export default ({ creditCards, setStep }) => {
  const { creditCardsClass, mainIcon, controlContainer } = useStyles()
  return (
    <div>
      <Icon iconName={Icons.creditCard} style={mainIcon} />
      <TypographyElement variant='heading1' spacing='0 0 16px 0'>{Text.title}</TypographyElement>
      <TypographyElement variant='body1' spacing='0 0 8px 0'>
        {Text.subTitle}
      </TypographyElement>
      <div className={creditCardsClass}>
        <CreditCardsCheckout noTitle />
      </div>
      <div className={controlContainer}>
        <Button
          disabled={!creditCards.length}
          height={54}
          label={Text.continue}
          onHandleClick={() => { setStep(confirmationStep) }}
          width={174}
          widthTablet='100%'
          widthMobile='100%'
        />
      </div>
    </div>
  )
}
